import { render } from "./catsurg.vue?vue&type=template&id=227223b8"
import script from "./catsurg.vue?vue&type=script&lang=js"
export * from "./catsurg.vue?vue&type=script&lang=js"

import "./catsurg.vue?vue&type=style&index=0&id=227223b8&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__